export default __webpack_public_path__ + "static/media/Neo.e7645010.png";